// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__AI-Landing-Page {
  color: #ffffff;
  background: #0d111c;
  text-align: center;
}

.BC-Page__AI-Landing-Page .Polaris-Page {
  max-width: 69rem;
  padding: 0 !important;
}

.BC-Page__AI-Landing-Page .Polaris-Page .Polaris-Page-Header__Row {
  display: block;
}

.BC-Page__AI-Landing-Page .Polaris-Page-Header__TitleWrapper {
  text-align: center;
}

.BC-Page__AI-Landing-Page .Polaris-Header-Title {
  font-size: 3rem;
  font-weight: 700;
  line-height: 3.625rem;
  background: linear-gradient(180deg, #ffffff 18.18%, rgba(255, 255, 255, 0.66) 80.7%);
  background-clip: content-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__AI-Landing-Page .Polaris-Header-Title__SubTitle p {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
  color: #ffffff;
}

.BC-Page__AI-Landing-Page .Polaris-Layout__Section {
  margin-top: 4rem;
}

.BC-Page__AI-Landing-Page .Polaris-Grid-Cell {
  align-self: center;
}

.BC-Page__AI-Landing-Page .text-underline {
  position: relative;
}

.BC-Page__AI-Landing-Page .text-underline::after {
  content: ' ';
  position: absolute;
  bottom: -0.375rem;
  right: 0;
  width: 100%;
  height: 0.25rem;
  background-position: center;
}

.BC-Page__AI-Landing-Page .text-underline.underline-01::after {
  background-image: url('https://cdn.boostcommerce.io/assets/landing-page/ai-powered/line1.svg');
}

.BC-Page__AI-Landing-Page .text-underline.underline-02::after {
  background-image: url('https://cdn.boostcommerce.io/assets/landing-page/ai-powered/line2.svg');
}

.BC-Page__AI-Landing-Page .text-underline .Polaris-TextStyle--variationNegative {
  background: linear-gradient(135deg, #ff5f6d 2.88%, #ffc371 100%);
  background-clip: content-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__AI-Landing-Page .section-header {
  padding: 1rem 0 2rem;
}

.BC-Page__AI-Landing-Page .section-header .Polaris-Heading {
  margin-bottom: 0.5rem;
  font-size: 2.5rem;
  line-height: 3rem;
  background: linear-gradient(180deg, #ffffff 18.18%, rgba(255, 255, 255, 0.66) 80.7%);
  background-clip: content-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.BC-Page__AI-Landing-Page .Polaris-Subheading {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-transform: none;
}

.BC-Page__AI-Landing-Page .section-header .Polaris-Button {
  margin: 1.5rem 0 2rem;
}

.BC-Page__AI-Landing-Page .section-content {
  padding: 0 1.5rem;
}

.BC-Page__AI-Landing-Page .section-content.recommendation-blocks {
  margin-bottom: 4rem;
}

.BC-Page__AI-Landing-Page .section-content .block {
  margin-bottom: 2.5rem;
  padding: 1.5rem;
  border-radius: 4px;
  background: linear-gradient(
    180deg,
    rgba(238, 238, 238, 0.05) 0%,
    rgba(255, 229, 229, 0.012) 100%
  );
}

.BC-Page__AI-Landing-Page .section-content.transform-data-content .Polaris-Badge {
  background: var(--p-surface-warning-subdued-hovered);
}

.BC-Page__AI-Landing-Page .section-content.transform-data-content .Polaris-Badge > span {
  display: flex;
  gap: 4px;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
}

.BC-Page__AI-Landing-Page .section-content.transform-data-content .Polaris-Badge > span span {
  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.BC-Page__AI-Landing-Page .block-header {
  margin: 1rem 0 2rem;
}

.BC-Page__AI-Landing-Page .Polaris-Grid-Cell .block-header {
  text-align: left;
}

.BC-Page__AI-Landing-Page .block-header .Polaris-Heading {
  margin-bottom: 0.5rem;
  font-size: 1.625rem;
  font-weight: 400;
  line-height: 2rem;
}

.BC-Page__AI-Landing-Page .Polaris-Card {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),
    linear-gradient(250.36deg, rgba(108, 234, 255, 0.1) 3.11%, rgba(55, 77, 237, 0.1) 97.83%);
}

.BC-Page__AI-Landing-Page .analytics-content .Polaris-Card {
  background: rgba(0, 164, 124, 0.1);
}

.BC-Page__AI-Landing-Page .Polaris-Card .card-content {
  margin: 1rem;
}

.BC-Page__AI-Landing-Page .Polaris-Card .card-content .title {
  margin-bottom: 0.25rem;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.75rem;
  color: #f7fdfc;
}

.BC-Page__AI-Landing-Page .Polaris-Card .card-content .content {
  padding-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  min-height: 4.75rem;
}

.BC-Page__AI-Landing-Page .analytics-content .Polaris-Card .card-content .title {
  font-size: 1rem;
}

.BC-Page__AI-Landing-Page .analytics-content .Polaris-Card .card-content .content {
  padding-left: 2rem;
  padding-right: 2rem;
}

.BC-Page__AI-Landing-Page .analytics-content .Polaris-Button {
  margin: 0 2rem 2rem;
}

.BC-Page__AI-Landing-Page .transform-data-content {
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  margin-bottom: 2rem;
}

.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card {
  text-align: left;
  background: linear-gradient(135deg, #ff5f6d 2.88%, #ffc371 100%);
  padding: 2rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
}

.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card .card-content {
  align-self: center;
}

.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card .content {
  padding-right: 2rem;
}

.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card .card-content .title {
  font-size: 1.75rem;
  line-height: 2rem;
  margin: 0.75rem 0;
}

.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card img {
  max-width: 20.75rem;
}

.BC-Page__AI-Landing-Page .reviews-slideshow {
  position: relative;
  margin-bottom: 7.25rem;
}

.BC-Page__AI-Landing-Page .reviews-slideshow::after {
  content: ' ';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  background: #1dbf98;
  opacity: 0.2;
  filter: blur(100px);
}

.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-cards {
  margin: 0;
}

.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-item {
  width: 32%;
}

.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-item .Polaris-Card {
  background: linear-gradient(180deg, rgba(0, 255, 191, 0.2) 0%, rgba(24, 146, 116, 0.2) 100%);
  text-align: left;
  padding: 1.25rem;
}

.BC-Page__AI-Landing-Page .reviews-slideshow .review-header {
  display: flex;
  justify-content: space-between;
}

.BC-Page__AI-Landing-Page .reviews-slideshow .review-time {
  margin: 0.25rem 0 0.75rem;
  color: #adf0df;
}

.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-controls {
  justify-content: center;
  margin: 2rem;
}

.BC-Page__AI-Landing-Page .button-unlock {
  background: var(--decorative-surface-one, #ffc96b);
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.08);
  font-weight: 500;
  margin-right: 0.75rem;
  align-items: center;
  gap: 4px;
  border: unset;
}

.BC-Page__AI-Landing-Page .button-unlock .Polaris-Icon svg {
  fill: var(--p-icon-hovered);
}

.BC-Page__AI-Landing-Page .unlock-button-disabled {
  background: #f7f3ef !important;
  border: 1px solid #d1d1d1;
  font-weight: 500;
  color: gray !important;
  cursor: unset;
}

.BC-Page__AI-Landing-Page .unlock-button-disabled:hover {
  cursor: unset;
}

.BC-Page__AI-Landing-Page .unlock-button-disabled .Polaris-Icon svg {
  fill: var(--p-icon);
}

@media (max-width: 90em) {
  .BC-Page__AI-Landing-Page .block .Polaris-Grid {
    gap: var(--pc-grid-gap-xl, var(--p-space-6));
  }

  .BC-Page__AI-Landing-Page .Polaris-Grid {
    gap: var(--pc-grid-gap-xl, var(--p-space-5));
  }
}

@media (min-width: 48em) {
  .BC-Page__AI-Landing-Page .block > .block-header .Polaris-Subheading {
    padding: 0 9rem;
  }
}

@media (min-width: 30.625em) {
  .BC-Page__AI-Landing-Page .analytics-content .Polaris-Card:first-child .card-content .content {
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .BC-Page__AI-Landing-Page .analytics-content .Polaris-Card:last-child .card-content .content {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

@media (max-width: 30.625em) {
  .BC-Page__AI-Landing-Page .reviews-slideshow .carousel-item {
    width: 99%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/landing-page/ai-powered.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oFAAoF;EACpF,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,8FAA8F;AAChG;;AAEA;EACE,gEAAgE;EAChE,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,oFAAoF;EACpF,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB;;;;GAIC;AACH;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sEAAsE;EACtE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;6FAC2F;AAC7F;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gEAAgE;EAChE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;;EAEN,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4FAA4F;EAC5F,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kDAAkD;EAClD,0FAA0F;EAC1F,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".BC-Page__AI-Landing-Page {\n  color: #ffffff;\n  background: #0d111c;\n  text-align: center;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Page {\n  max-width: 69rem;\n  padding: 0 !important;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Page .Polaris-Page-Header__Row {\n  display: block;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Page-Header__TitleWrapper {\n  text-align: center;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Header-Title {\n  font-size: 3rem;\n  font-weight: 700;\n  line-height: 3.625rem;\n  background: linear-gradient(180deg, #ffffff 18.18%, rgba(255, 255, 255, 0.66) 80.7%);\n  background-clip: content-box;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Header-Title__SubTitle p {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n  color: #ffffff;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Layout__Section {\n  margin-top: 4rem;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Grid-Cell {\n  align-self: center;\n}\n\n.BC-Page__AI-Landing-Page .text-underline {\n  position: relative;\n}\n\n.BC-Page__AI-Landing-Page .text-underline::after {\n  content: ' ';\n  position: absolute;\n  bottom: -0.375rem;\n  right: 0;\n  width: 100%;\n  height: 0.25rem;\n  background-position: center;\n}\n\n.BC-Page__AI-Landing-Page .text-underline.underline-01::after {\n  background-image: url('https://cdn.boostcommerce.io/assets/landing-page/ai-powered/line1.svg');\n}\n\n.BC-Page__AI-Landing-Page .text-underline.underline-02::after {\n  background-image: url('https://cdn.boostcommerce.io/assets/landing-page/ai-powered/line2.svg');\n}\n\n.BC-Page__AI-Landing-Page .text-underline .Polaris-TextStyle--variationNegative {\n  background: linear-gradient(135deg, #ff5f6d 2.88%, #ffc371 100%);\n  background-clip: content-box;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__AI-Landing-Page .section-header {\n  padding: 1rem 0 2rem;\n}\n\n.BC-Page__AI-Landing-Page .section-header .Polaris-Heading {\n  margin-bottom: 0.5rem;\n  font-size: 2.5rem;\n  line-height: 3rem;\n  background: linear-gradient(180deg, #ffffff 18.18%, rgba(255, 255, 255, 0.66) 80.7%);\n  background-clip: content-box;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Subheading {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.25rem;\n  text-transform: none;\n}\n\n.BC-Page__AI-Landing-Page .section-header .Polaris-Button {\n  margin: 1.5rem 0 2rem;\n}\n\n.BC-Page__AI-Landing-Page .section-content {\n  padding: 0 1.5rem;\n}\n\n.BC-Page__AI-Landing-Page .section-content.recommendation-blocks {\n  margin-bottom: 4rem;\n}\n\n.BC-Page__AI-Landing-Page .section-content .block {\n  margin-bottom: 2.5rem;\n  padding: 1.5rem;\n  border-radius: 4px;\n  background: linear-gradient(\n    180deg,\n    rgba(238, 238, 238, 0.05) 0%,\n    rgba(255, 229, 229, 0.012) 100%\n  );\n}\n\n.BC-Page__AI-Landing-Page .section-content.transform-data-content .Polaris-Badge {\n  background: var(--p-surface-warning-subdued-hovered);\n}\n\n.BC-Page__AI-Landing-Page .section-content.transform-data-content .Polaris-Badge > span {\n  display: flex;\n  gap: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n}\n\n.BC-Page__AI-Landing-Page .section-content.transform-data-content .Polaris-Badge > span span {\n  background: linear-gradient(135.64deg, #c830e1 16.99%, #fe4a25 84.55%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.BC-Page__AI-Landing-Page .block-header {\n  margin: 1rem 0 2rem;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Grid-Cell .block-header {\n  text-align: left;\n}\n\n.BC-Page__AI-Landing-Page .block-header .Polaris-Heading {\n  margin-bottom: 0.5rem;\n  font-size: 1.625rem;\n  font-weight: 400;\n  line-height: 2rem;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Card {\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)),\n    linear-gradient(250.36deg, rgba(108, 234, 255, 0.1) 3.11%, rgba(55, 77, 237, 0.1) 97.83%);\n}\n\n.BC-Page__AI-Landing-Page .analytics-content .Polaris-Card {\n  background: rgba(0, 164, 124, 0.1);\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Card .card-content {\n  margin: 1rem;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Card .card-content .title {\n  margin-bottom: 0.25rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n  line-height: 1.75rem;\n  color: #f7fdfc;\n}\n\n.BC-Page__AI-Landing-Page .Polaris-Card .card-content .content {\n  padding-bottom: 1rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  min-height: 4.75rem;\n}\n\n.BC-Page__AI-Landing-Page .analytics-content .Polaris-Card .card-content .title {\n  font-size: 1rem;\n}\n\n.BC-Page__AI-Landing-Page .analytics-content .Polaris-Card .card-content .content {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.BC-Page__AI-Landing-Page .analytics-content .Polaris-Button {\n  margin: 0 2rem 2rem;\n}\n\n.BC-Page__AI-Landing-Page .transform-data-content {\n  padding-bottom: 1.5rem;\n  padding-top: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card {\n  text-align: left;\n  background: linear-gradient(135deg, #ff5f6d 2.88%, #ffc371 100%);\n  padding: 2rem 1.5rem;\n  margin-bottom: 1.5rem;\n  display: flex;\n}\n\n.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card .card-content {\n  align-self: center;\n}\n\n.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card .content {\n  padding-right: 2rem;\n}\n\n.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card .card-content .title {\n  font-size: 1.75rem;\n  line-height: 2rem;\n  margin: 0.75rem 0;\n}\n\n.BC-Page__AI-Landing-Page .transform-data-content .Polaris-Card img {\n  max-width: 20.75rem;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow {\n  position: relative;\n  margin-bottom: 7.25rem;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow::after {\n  content: ' ';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n\n  background: #1dbf98;\n  opacity: 0.2;\n  filter: blur(100px);\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-cards {\n  margin: 0;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-item {\n  width: 32%;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-item .Polaris-Card {\n  background: linear-gradient(180deg, rgba(0, 255, 191, 0.2) 0%, rgba(24, 146, 116, 0.2) 100%);\n  text-align: left;\n  padding: 1.25rem;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow .review-header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow .review-time {\n  margin: 0.25rem 0 0.75rem;\n  color: #adf0df;\n}\n\n.BC-Page__AI-Landing-Page .reviews-slideshow .carousel-controls {\n  justify-content: center;\n  margin: 2rem;\n}\n\n.BC-Page__AI-Landing-Page .button-unlock {\n  background: var(--decorative-surface-one, #ffc96b);\n  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset, 0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n  font-weight: 500;\n  margin-right: 0.75rem;\n  align-items: center;\n  gap: 4px;\n  border: unset;\n}\n\n.BC-Page__AI-Landing-Page .button-unlock .Polaris-Icon svg {\n  fill: var(--p-icon-hovered);\n}\n\n.BC-Page__AI-Landing-Page .unlock-button-disabled {\n  background: #f7f3ef !important;\n  border: 1px solid #d1d1d1;\n  font-weight: 500;\n  color: gray !important;\n  cursor: unset;\n}\n\n.BC-Page__AI-Landing-Page .unlock-button-disabled:hover {\n  cursor: unset;\n}\n\n.BC-Page__AI-Landing-Page .unlock-button-disabled .Polaris-Icon svg {\n  fill: var(--p-icon);\n}\n\n@media (max-width: 90em) {\n  .BC-Page__AI-Landing-Page .block .Polaris-Grid {\n    gap: var(--pc-grid-gap-xl, var(--p-space-6));\n  }\n\n  .BC-Page__AI-Landing-Page .Polaris-Grid {\n    gap: var(--pc-grid-gap-xl, var(--p-space-5));\n  }\n}\n\n@media (min-width: 48em) {\n  .BC-Page__AI-Landing-Page .block > .block-header .Polaris-Subheading {\n    padding: 0 9rem;\n  }\n}\n\n@media (min-width: 30.625em) {\n  .BC-Page__AI-Landing-Page .analytics-content .Polaris-Card:first-child .card-content .content {\n    padding-left: 7rem;\n    padding-right: 7rem;\n  }\n\n  .BC-Page__AI-Landing-Page .analytics-content .Polaris-Card:last-child .card-content .content {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n}\n\n@media (max-width: 30.625em) {\n  .BC-Page__AI-Landing-Page .reviews-slideshow .carousel-item {\n    width: 99%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
